import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import {
	Spin,
	Table,
	Dropdown,
	Icon,
	Button,
	Menu,
	Divider,
	Drawer,
	Modal,
	FormModel,
	InputNumber,
	Select
} from "ant-design-vue";
import { Column } from "ant-design-vue/lib";
import "ant-design-vue/dist/antd.less";
import { Paths } from "@/util/paths";
import { MethodologyTypeItems, MethodologyTypeItemsWithAll } from "@/util/constants";
import { fmtMsg, GLUtil, ActionItem, MessageHelper, NotificationType } from "commonui";
import { VersionGroupModel } from "@/services/version-group";
import {
	ILessonPlanListModel,
	ILessonPlanTemplateModel,
	ILessonPlanVersionModel,
	ILessonPlanVersionSimpleModel,
	LessonPlanListColumns
} from "@/models/lesson-plan";
import { VCSLevelModel } from "@/models/title-list-model";
import LessonPlanListState from "@/modules/lesson-plan-list";
import { VersionGroupModule } from "@/modules/versiongroup";
import { LessonPlanLocale, CommonLocale } from "@/locales/localeid";
import {
	AccessLevel,
	LessonPlanAction,
	LessonPlanActionStatus,
	LessonPlanVersionStatus,
	MethodologyType,
	MethodologyTypeEnum
} from "@/util/enum";
import PageTitle from "@/components/page-title/page-title.vue";
import VersionGroupSelect from "@/components/version-group-select/version-group-select.vue";
import MethodologySelect from "@/components/methodology-select/methodology-select.vue";
import LessonPlanVersionSelect from "./components/lesson-plan-version-select/lesson-plan-version-select.vue";
import UnitSelect from "./components/unit-select/unit-select.vue";
import {
	FrontMatterURLRequestModel,
	ILessonPlanListService,
	ILessonPlanVersionService,
	LessonPlanListService,
	LessonPlanVersionService
} from "@/services/lesson-plan";
import LessonPlanTemplateDownload from "../components/template-download/template-download.vue";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";
import FrontMatter from "./components/front-matter-upload/front-matter.vue";
import Grid from "@/components/wijmo-grid/grid/grid.vue";

@Component({
	components: {
		Grid,
		"a-spin": Spin,
		"a-table": Table,
		"a-dropdown": Dropdown,
		"a-icon": Icon,
		"a-button": Button,
		"a-menu": Menu,
		"a-menu-item": Menu.Item,
		"a-divider": Divider,
		"a-drawer": Drawer,
		PageTitle,
		VersionGroupSelect,
		MethodologySelect,
		LessonPlanVersionSelect,
		FrontMatter,
		UnitSelect,
		ActionItem,
		Modal,
		Form: FormModel,
		FormItem: FormModel.Item,
		InputNumber,
		LessonPlanTemplateDownload,
		Select,
		Option: Select.Option
	}
})
export default class LessonPlanList extends Vue {
	private lessonPlanListModule = getModule(LessonPlanListState);
	private lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	private versionGroupModule = VersionGroupModule; // for watch need to create local reference
	private defaultColumns: Column[] = [
		// {
		// 	title: fmtMsg(LessonPlanLocale.LessonPlanListColumnSequenceTitle),
		// 	dataIndex: LessonPlanListColumns.SequenceColumn,
		// 	key: LessonPlanListColumns.SequenceColumn,
		// 	width: "20%",
		// },
		{
			title: fmtMsg(LessonPlanLocale.LessonPlanListColumnNameTitle),
			dataIndex: LessonPlanListColumns.NameColumn,
			key: LessonPlanListColumns.NameColumn,
			width: "50%",
			className: "name-column",
			scopedSlots: { customRender: "name" }
		},
		{
			title: fmtMsg(LessonPlanLocale.LessonPlanListColumnEstimatedTimeTitle),
			dataIndex: LessonPlanListColumns.EstimatedTime4MinuteColumn,
			key: LessonPlanListColumns.EstimatedTime4MinuteColumn,
			width: "40%"
		},
		{
			title: "",
			dataIndex: LessonPlanListColumns.ActionColumn,
			key: LessonPlanListColumns.ActionColumn,
			width: "10%",
			scopedSlots: { customRender: "action" },
			align: "center"
		}
	];
	private columns: Column[] = [];
	private currentAction: LessonPlanActionStatus = LessonPlanActionStatus.Edit;
	public addLessonModalVisible: boolean = false;
	public addLessonButtonLoading: boolean = false;
	public copyLessonButtonLoading: boolean = false;
	public enableaddLessonSaveButton: boolean = true;
	public addLessonFormModel = {
		createLessonPlanCount: 1
	};

	public createUnitFormRules = {
		createLessonPlanCount: [
			{
				required: true,
				message: fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountRequiredMsg),
				trigger: "change"
			},
			{ validator: this.lessonPlanCountValidator, trigger: "change" }
		]
	};

	public labelCol = {
		span: 18
	};

	public wrapperCol = {
		span: 6
	};

	public accessLevel = AccessLevel;

	public copyLessonPlanVisible: boolean = false;

	public targetlessonPlanVersions: ILessonPlanVersionSimpleModel[] = [];
	public targetLPV: ILessonPlanVersionSimpleModel = {
		id: "",
		name: "",
		description: "",
		methodology: -1,
		status: -1,
		versionGroupId: "",
		combinedNameMethodology: ""
	};
	lessonPlanVersionService: ILessonPlanVersionService = LessonPlanVersionService();

	validateaddLessonForm(item: string, isPassed: boolean, error: string) {
		if (isPassed != this.enableaddLessonSaveButton) this.enableaddLessonSaveButton = isPassed;
	}

	lessonPlanCountValidator(rule: any, value: number, callback: (msg?: string) => void) {
		if (value <= 0 || value > 50) {
			callback(fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountErrorText));
		}
		callback();
	}

	get isREP(): boolean {
		return this.lessonPlanListModule.currentMethodology === MethodologyTypeEnum.REP;
	}

	get addLessonPlanModalTitle(): string {
		return this.isREP
			? fmtMsg(LessonPlanLocale.LessonPlanPlayListAddModalTitle)
			: fmtMsg(LessonPlanLocale.LessonPlanAddModalTitle);
	}

	get addLessonPlanCountLabel(): string {
		return this.isREP
			? fmtMsg(LessonPlanLocale.LessonPlanListAddPlaylistCountLabelText)
			: fmtMsg(LessonPlanLocale.LessonPlanListAddLessonCountLabelText);
	}

	get pageTitle(): string {
		return this.isREP
			? fmtMsg(LessonPlanLocale.LessonPlanListPlaylists)
			: fmtMsg(LessonPlanLocale.LessonPlanListPageTitle);
	}

	get addButtonText(): string {
		return this.isREP
			? this.formatMessage(LessonPlanLocale.LessonPlanPlayListBuilderAddButtonTitle)
			: this.formatMessage(LessonPlanLocale.LessonPlanMasterPlanAddLessonButtonTitle);
	}

	get copyToButtonText(): string {
		return this.formatMessage(LessonPlanLocale.LessonPlanMasterPlanCopyLessonButtonTitle);
	}

	get loading(): boolean {
		return this.lessonPlanListModule.loading;
	}

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	get commonLocale(): any {
		return CommonLocale;
	}

	get lessonPlanVersionStatus(): any {
		return LessonPlanVersionStatus;
	}

	get lessonPlanAction(): any {
		return LessonPlanAction;
	}

	get lessonPlanActionStatus(): any {
		return LessonPlanActionStatus;
	}

	get lessonPlanListColumns(): any {
		return LessonPlanListColumns;
	}

	get versionGroups(): VersionGroupModel[] {
		return this.lessonPlanListModule.versionGroups;
	}

	get defaultVersionGroup(): string {
		return this.lessonPlanListModule.currentVersionGroup.id;
	}

	get defaultMethodology(): MethodologyTypeEnum {
		return this.lessonPlanListModule.currentMethodology;
	}

	get methodologyItems(): Map<MethodologyTypeEnum, string> {
		return MethodologyTypeItemsWithAll;
	}

	get lessonPlanVersions(): ILessonPlanVersionModel[] {
		return this.lessonPlanListModule.currentLessonPlanVersions;
	}

	get defaultLessonPlanVersion(): any {
		return this.lessonPlanListModule.currentLessonPlanVersion;
	}

	get units(): VCSLevelModel[] {
		return this.lessonPlanListModule.currentUnits;
	}

	get defaultUnit(): number {
		return this.lessonPlanListModule.currentUnit.id;
	}

	get lessonPlans(): ILessonPlanListModel[] {
		return this.lessonPlanListModule.lessonPlans.map((lessonPlan) => ({
			...lessonPlan,
			exposureConversation: `${lessonPlan.conversationCount} / ${lessonPlan[LessonPlanListColumns.ExposureCount]}`
		}));
	}

	get lessonPlanVersionFormTitle(): string {
		switch (this.currentAction) {
			case LessonPlanActionStatus.Edit:
				return fmtMsg(LessonPlanLocale.LessonPlanVersionEditFormTitle);
			case LessonPlanActionStatus.Add:
			default:
				return fmtMsg(LessonPlanLocale.LessonPlanVersionAddFormTitle);
		}
	}

	get lessonPlanIsValid(): boolean {
		return (
			this.lessonPlanListModule.currentLessonPlanVersion.id != undefined &&
			this.lessonPlanListModule.currentUnit.id != undefined
		);
	}

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	mounted(): void {
		this.versionGroupModule.setDisabled(false);
		const currentPath = this.$route;
		let currentUnitId = 1;
		if (currentPath.query.unitId) {
			currentUnitId = Number(currentPath.query.unitId);
		}
		const params: FrontMatterURLRequestModel = {
			lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
			unitId: currentUnitId
		};
		this.lessonPlanVersionService
			.getFrontMatterURL(params)
			.then((data) => {
				this.lessonPlanListModule.setFrontMatterURL(data.frontMatterFileUrl);
			})
			.catch((e) => {
				this.lessonPlanListModule.setFrontMatterURL("");
			});
	}

	async getTargetLPVs(): Promise<void> {
		const selectedVersionGroups = [this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId];
		const methodologyTypes =
			this.lessonPlanListModule.currentMethodology === MethodologyTypeEnum.REP
				? [MethodologyTypeEnum.REP]
				: [
						MethodologyTypeEnum.Classic,
						MethodologyTypeEnum.Digital,
						MethodologyTypeEnum.Independent,
						MethodologyTypeEnum.Remote
				  ];
		const allLPVs = await this.lessonPlanVersionService.getLessonPlanVersionsByTypes(
			selectedVersionGroups as string[],
			methodologyTypes,
			true
		);
		this.targetlessonPlanVersions = allLPVs.filter(
			(lpv) => lpv.id !== this.lessonPlanListModule.currentLessonPlanVersion.id
		);
		if (this.targetlessonPlanVersions.length) {
			this.targetLPV = this.targetlessonPlanVersions[0];
		} else {
			this.targetLPV.id = "";
		}
	}

	destroyed(): void {
		this.versionGroupModule.setDisabled(true);
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	doAction(event: any, record: ILessonPlanListModel): void {
		switch (event.key) {
			case LessonPlanAction.Remove:
				this.onDeleteLessonPlan(record.id as string);
				break;
			case LessonPlanAction.MoveUp:
				this.onMoveUpLessonPlanItem(record);
				break;
			case LessonPlanAction.MoveDown:
				this.onMoveDownLessonPlanItem(record);
				break;
			default:
				break;
		}
	}

	get masterPlanRouter(): string {
		return GLUtil.pathStringify(Paths.MasterPlan, {
			versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
			methodology: this.lessonPlanListModule.currentMethodology,
			lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
			unitId: this.lessonPlanListModule.currentUnit.id
		});
	}

	get lessonPlanTemplates(): ILessonPlanTemplateModel[] {
		return this.lessonPlanTemplateModule.lessonPlanTemplates;
	}

	getMasterPlanLessonPlanEditorRouter({ id, name }: any): string {
		return GLUtil.pathStringify(Paths.MasterPlanLessonPlanEditor, {
			versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
			methodology: this.lessonPlanListModule.currentMethodology,
			lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
			unitId: this.lessonPlanListModule.currentUnit.id,
			lessonPlanId: id
		});
	}

	@Watch("versionGroupModule.selectedGsVersion")
	@Watch("versionGroupModule.selectedLsVersion")
	onVersionGroupChanged(value: VersionGroupModel): void {
		// this.lessonPlanListModule.setCurrentVersionGroup(value);
		this.lessonPlanListModule.fetchLessonPlanVersions({ versionGroup: value });
	}

	isCurrentMethodologyClassic() {
		return !this.lessonPlanListModule.currentMethodology;
	}

	isCurrentMethodologyIndependent() {
		return this.lessonPlanListModule.currentMethodology === MethodologyTypeEnum.Independent;
	}

	onMethodologyChanged(value: MethodologyTypeEnum): void {
		this.lessonPlanListModule.setCurrentMethodology(value);
		this.lessonPlanListModule.fetchLessonPlanVersions({ methodology: value }).then((data) => {
			const params: FrontMatterURLRequestModel = {
				lessonPlanVersionId: data.id,
				unitId: this.lessonPlanListModule.currentUnit.id
			};
			this.lessonPlanVersionService
				.getFrontMatterURL(params)
				.then((data) => {
					this.lessonPlanListModule.setFrontMatterURL(data.frontMatterFileUrl);
				})
				.catch((e) => {
					this.lessonPlanListModule.setFrontMatterURL("");
				});
		});
		this.getTargetLPVs();
	}

	onLessonPlanVersionChanged(value: ILessonPlanVersionModel): void {
		this.lessonPlanListModule.setCurrentLessonPlanVersion(value);
		this.lessonPlanListModule.refreshLessonPlans({ lessonPlanVersion: value });
		const params: FrontMatterURLRequestModel = {
			lessonPlanVersionId: value.id,
			unitId: this.lessonPlanListModule.currentUnit.id
		};
		this.lessonPlanVersionService
			.getFrontMatterURL(params)
			.then((data) => {
				this.lessonPlanListModule.setFrontMatterURL(data.frontMatterFileUrl);
			})
			.catch((e) => {
				this.lessonPlanListModule.setFrontMatterURL("");
			});
	}

	onUnitChanged(value: VCSLevelModel): void {
		this.lessonPlanListModule.setCurrentUnit(value);
		this.lessonPlanListModule.refreshLessonPlans({ unit: value });
		const params: FrontMatterURLRequestModel = {
			lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
			unitId: value.id
		};
		this.lessonPlanVersionService
			.getFrontMatterURL(params)
			.then((data) => {
				this.lessonPlanListModule.setFrontMatterURL(data.frontMatterFileUrl);
			})
			.catch((e) => {
				this.lessonPlanListModule.setFrontMatterURL("");
			});
	}

	onAddLessonPlanVersion(event: any): void {
		this.addLessonModalVisible = true;
		// this.lessonPlanListModule.saveLessonPlanData({ action: LessonPlanActionStatus.Add });
	}

	onDeleteLessonPlan(lessonPlanId: string): void {
		Modal.confirm({
			title: fmtMsg(LessonPlanLocale.LessonPlanDeletePromptMessage),
			okText: fmtMsg(CommonLocale.CommonDeleteButtonText),
			okType: "danger",
			onOk: () => {
				this.lessonPlanListModule.deleteLessonPlan(lessonPlanId);
			}
		});
	}

	canNavigate2MasterPlan(): boolean {
		return (
			this.lessonPlanListModule.currentVersionGroups.length > 0 &&
			this.lessonPlanListModule.currentLessonPlanVersion.id !== undefined &&
			this.lessonPlanListModule.currentUnit.id > 0
		);
	}

	canNavigate2ConvMasterPlan(): boolean {
		return this.canNavigate2MasterPlan();
	}

	onNavigate2MasterPlan(event: any): void {
		this.$router.push({
			path: GLUtil.pathStringify(Paths.MasterPlan, {
				versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
				methodology: this.lessonPlanListModule.currentMethodology,
				lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
				unitId: this.lessonPlanListModule.currentUnit.id
			})
		});
	}

	onNavigate2MasterPlanLessonPlanEditor({ id, name }: any): void {
		this.$router.push({
			path: GLUtil.pathStringify(Paths.MasterPlanLessonPlanEditor, {
				versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
				methodology: this.lessonPlanListModule.currentMethodology,
				lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
				unitId: this.lessonPlanListModule.currentUnit.id,
				lessonPlanId: id
			})
		});
	}

	onNavigate2ConvMasterBuilder({ id, name }: any): void {
		this.$router.push({
			path: GLUtil.pathStringify(Paths.ConversationMasterBuilder, {
				// versionGroupId: this.lessonPlanListModule.currentLessonPlanVersion.versionGroupId,
				methodology: this.lessonPlanListModule.currentMethodology,
				lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id,
				unitId: this.lessonPlanListModule.currentUnit.id
			})
		});
	}

	canMoveUp(index) {
		return index > 0;
	}

	canMoveDown(index) {
		return index < this.lessonPlanListModule.lessonPlans.length - 1;
	}

	onMoveUpLessonPlanItem(record) {
		const preLessonPlanId: string = this.lessonPlanListModule.lessonPlans[
			this.lessonPlanListModule.lessonPlans.findIndex((d) => d.id === record.id) - 1
		].id as string;
		this.lessonPlanListModule.swapLessonPlans({ preLessonPlanId, nextLessonPlanId: record.id });
	}

	onMoveDownLessonPlanItem(record) {
		const nextLessonPlanId: string = this.lessonPlanListModule.lessonPlans[
			this.lessonPlanListModule.lessonPlans.findIndex((d) => d.id === record.id) + 1
		].id as string;
		this.lessonPlanListModule.swapLessonPlans({ preLessonPlanId: record.id, nextLessonPlanId });
	}

	isConvMasterPlanVisible() {
		return this.defaultMethodology === MethodologyTypeEnum.Independent && this.canNavigate2ConvMasterPlan();
	}

	onAddLessonModalClose() {
		this.addLessonButtonLoading = false;
		this.addLessonModalVisible = false;
		this.addLessonFormModel.createLessonPlanCount = 1;
	}

	onAddLessonModalOK() {
		const form = this.$refs.addLessonFormModel as FormModel;
		form.validate((valid) => {
			if (valid) {
				this.addLessonButtonLoading = true;
				// Get the count of lessonPlans to be added
				const lessonPlanCountToAdd = this.addLessonFormModel.createLessonPlanCount;

				// Call method.
				this.lessonPlanListModule
					.saveLessonPlansData({ action: LessonPlanActionStatus.Add, lessonPlanCount: lessonPlanCountToAdd })
					.then(() => {
						this.onAddLessonModalClose();
					})
					.catch(() => {
						this.onAddLessonModalClose();
					});
			}
		});
	}

	onDownloadTemplate(template: ILessonPlanTemplateModel) {
		this.lessonPlanListModule.downloadLessonPlans({
			template,
			lessonPlanVersionId: this.lessonPlanListModule.currentLessonPlanVersion.id as string,
			unitId: this.lessonPlanListModule.currentUnit.id
		});
	}

	async onLessonPlanCopy() {
		await this.getTargetLPVs();
		this.copyLessonPlanVisible = true;
	}

	get copyLessonPlanModalTitle(): string {
		return "Copy Lesson Plan";
	}

	onCopyLessonPlanModalClose() {
		this.copyLessonButtonLoading = false;
		this.copyLessonPlanVisible = false;
	}

	onCopyLessonPlanModalOk() {
		this.copyLessonButtonLoading = true;
		this.lessonPlanVersionService
			.copyUnitLessonPlan(
				this.lessonPlanListModule.currentLessonPlanVersion.id as string,
				this.targetLPV.id,
				this.lessonPlanListModule.currentUnit.id
			)
			.then(() => {
				MessageHelper.Message(
					NotificationType.Success,
					fmtMsg(LessonPlanLocale.LessonPlanListCopySuccessMsg, {
						0: this.lessonPlanListModule.currentLessonPlanVersion.name,
						1: this.targetLPV.name
					})
				);
				this.onCopyLessonPlanModalClose();
			})
			.catch(() => {
				this.onCopyLessonPlanModalClose();
			});
	}

	onCopyLessonPlanChange(lpvId: string) {
		this.targetLPV = this.targetlessonPlanVersions.find((lpv) => lpv.id === lpvId) as ILessonPlanVersionSimpleModel;
	}

	getMethodologyName(methodology: number) {
		return MethodologyTypeItems.get(methodology);
	}
}
